import { render, staticRenderFns } from "./deleteFeeConfig.vue?vue&type=template&id=413edbea"
import script from "./deleteFeeConfig.vue?vue&type=script&lang=js"
export * from "./deleteFeeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports